export const CloseIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="inherit">
        <path d="M26.3904 8.87523C26.1247 8.60965 25.7644 8.46045 25.3888 8.46045C25.0131 8.46045 24.6529 8.60965 24.3872 8.87523L17.8904 15.3721L11.3935 8.87523C11.1279 8.60965 10.7676 8.46045 10.392 8.46045C10.0163 8.46045 9.65603 8.60965 9.39037 8.87523C9.12478 9.14089 8.97559 9.50116 8.97559 9.87681C8.97559 10.2525 9.12478 10.6127 9.39037 10.8784L15.8872 17.3752L9.39037 23.8721C9.12478 24.1377 8.97559 24.498 8.97559 24.8736C8.97559 25.2493 9.12478 25.6096 9.39037 25.8752C9.65603 26.1408 10.0163 26.29 10.392 26.29C10.7676 26.29 11.1279 26.1408 11.3935 25.8752L17.8904 19.3784L24.3872 25.8752C24.6529 26.1408 25.0131 26.29 25.3888 26.29C25.7644 26.29 26.1247 26.1408 26.3904 25.8752C26.656 25.6096 26.8051 25.2493 26.8051 24.8736C26.8051 24.498 26.656 24.1377 26.3904 23.8721L19.8935 17.3752L26.3904 10.8784C26.656 10.6127 26.8051 10.2525 26.8051 9.87681C26.8051 9.50116 26.656 9.14089 26.3904 8.87523Z" fill="inherit"/>
        </svg>
    `,
      }}
    />
  );
};
